import { render, staticRenderFns } from "./fix-address-info.vue?vue&type=template&id=ad628848&scoped=true&"
import script from "./fix-address-info.vue?vue&type=script&lang=js&"
export * from "./fix-address-info.vue?vue&type=script&lang=js&"
import style0 from "./fix-address-info.vue?vue&type=style&index=0&id=ad628848&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad628848",
  null
  
)

export default component.exports